export let VideoSource = /*#__PURE__*/function (VideoSource) {
  VideoSource["YOUTUBE"] = "youtube";
  VideoSource["VIMEO"] = "vimeo";
  VideoSource["LOOM"] = "loom";
  VideoSource["UNSUPPORTED"] = "unsupported";
  return VideoSource;
}({});
export const videoPlayerBorderRadius = '8px';
export const getVideoSource = parsedVideoLink => {
  const hostname = parsedVideoLink.hostname;
  const youtubeHostnames = ['www.youtube.com', 'youtube.com', 'youtu.be'];
  const vimeoHostname = ['vimeo.com'];
  const loomHostnames = ['www.loom.com', 'loom.com'];
  if (youtubeHostnames.includes(hostname)) {
    return VideoSource.YOUTUBE;
  } else if (vimeoHostname.includes(hostname)) {
    return VideoSource.VIMEO;
  } else if (loomHostnames.includes(hostname)) {
    return VideoSource.LOOM;
  } else {
    return VideoSource.UNSUPPORTED;
  }
};